import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import Convocation from "./pages/Convocation";
import Coach from "./pages/Coach";
import Aide from "./pages/Aide";
import Fiche from "./pages/Fiche";
import FicheEncadrant from "./pages/FicheEncadrant";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09, prevent: (node) => Boolean(node.closest?.("[role=dialog], [data-radix-popper-content-wrapper]")) });
    return () => { lenis.destroy(); };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Convocation />} />
        <Route path="/coach" element={<Coach />} />
        <Route path="/aide" element={<Aide />} />
        <Route path="/fiche" element={<Fiche />} />
        <Route path="/fiche-encadrant" element={<FicheEncadrant />} />
      </Routes>
      <Toaster position="bottom-center" />
    </BrowserRouter>
  );
}

export default App;
